module.exports = __webpack_public_path__ + "img/9788964960813.21b282ba.jpg";